import { createFileRoute } from "@tanstack/react-router";
import { ProductPage } from "@/components/site/ProductPage";
import { PortfolioCalculator } from "@/components/site/PortfolioCalculator";
import { PortfolioExtras } from "@/components/site/PortfolioExtras";
import { getProduct } from "@/data/products";
import { getProductHero } from "@/data/productHeroes";
import { buildHead } from "@/lib/seo-head";
import { LiveDscrRateSection } from "@/components/rates/LiveDscrRateSection";

const SLUG = "portfolio-rental-loans";
const PRODUCT = getProduct(SLUG)!;
const HERO = getProductHero(SLUG);
const URL = `/${SLUG}`;

const KEYWORDS = [
  "portfolio rental loan",
  "blanket DSCR loan",
  "blanket mortgage for rental portfolio",
  "portfolio loan for landlords",
  "multiple property mortgage",
  "cross collateralized rental loan",
  "5+ property blanket loan",
  "portfolio loan LLC",
  "portfolio loan rates",
  "single mortgage multiple rentals",
  "portfolio refinance rental properties",
  "release clause blanket loan",
].join(", ");

export const Route = createFileRoute("/portfolio-rental-loans/")({
  head: () =>
    buildHead({
      title: "Portfolio Rental Loans: Blanket DSCR Financing",
      description:
        "Blanket DSCR loans that consolidate 5+ rental properties into a single mortgage — one payment, one closing, one appraisal package.",
      url: URL,
      keywords: KEYWORDS,
      image: HERO?.src,
      imageAlt: HERO?.alt,
      breadcrumbs: [
        { name: "Home", url: "/" },
        { name: PRODUCT.shortName, url: URL },
      ],
      service: { name: PRODUCT.name },
      faqs: PRODUCT.faq.map((f) => ({ q: f.q, a: f.a })),
    }),

  component: () => (
    <ProductPage
      product={PRODUCT}
      hideBaseTools
      topTools={
        <>
          <PortfolioCalculator />
          <LiveDscrRateSection
            strategyCards
            id="live-rates"
            eyebrow={"Live pricing · DSCR"}
            heading={"Live DSCR pricing on a single-property scenario"}
            paragraphs={[
              "These are actual pricing responses returned for a sample business-purpose DSCR scenario on non-owner-occupied investment property - rate, APR, borrower points or lender credit, estimated principal and interest, and lock period from the same quote. Pricing changes intraday and is not a loan approval, commitment, or guarantee of financing.",
            ]}
            links={[
              { to: "/investment-property-rates", label: "Price your own DSCR scenario" },
              { to: "/rates", label: "See today's investor rate bands" },
            ]}
          />
        </>
      }
      extraTools={<PortfolioExtras />}

    />
  ),
});
